import { useContext } from "react";
import { ColorHeaderContext } from "../contexts/colorHeader";


export const useColor = () => useContext(ColorHeaderContext);